<template>
  <div :class="['card', { 'no-padding': noPadding }]">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    noPadding: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.card {
  box-sizing: border-box;
  padding: 1rem;
  background: var(--card-background);
  border-radius: 0.25rem;
  box-shadow: 0 0.1rem 0.25rem 0 var(--shadow-color);
}
.no-padding {
  padding: 0;
}
</style>
